module.exports = __webpack_public_path__ + "assets/img/note.bb45384e.svg";